import { Grid, Typography } from '@material-ui/core'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import TextField from '../../../components/Form/TextField'
import { useStyles } from '../Style'
type props = any;

const MvmCompositionPartInfo: React.FC<props> = ({ mvm, control, setValue, full, type, movementType }) => {

    const classes = useStyles();
    const { t: tMvm } = useTranslation("Mvm")

    useEffect(() => {
        
        if(!mvm)
            return
        
        setValue("mvmNumberPart" + movementType, mvm.mvmNumber)
        setValue("vehiclePlateNumberPart" + movementType, mvm.vehiclePlateNumber)
        setValue("statusPart" + movementType, mvm.statusDescription)
        setValue("entranceDatePart" + movementType, mvm.entranceDate)
        setValue("exitDatePart" + movementType, mvm.exitDate)
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mvm])
  
    return (
        <Grid style={{ marginTop: 20, width: "98%", marginBottom: 10 }}>
            <Typography className={classes.root} style={{ marginLeft: 10 }} >
                {tMvm("generalInfo") + ' ' + type + ' ' + movementType}
            </Typography>
            <Grid container spacing={1} >
                
                <Grid item xs={2}>
                    <TextField 
                        label={tMvm("mvmNumber")} 
                        name={"mvmNumberPart" + movementType} 
                        control={control}
                        fullWidth
                        InputLabelProps={{shrink:true}}
                        InputProps={{
                            readOnly: true,
                            classes: {
                                input: classes.inputBlocked
                            }
                        }}/> 
                </Grid>

                <Grid item xs={2}>
                    <TextField 
                        label={tMvm("vehiclePlateNumber")} 
                        name={"vehiclePlateNumberPart" + movementType} 
                        control={control}
                        fullWidth
                        InputLabelProps={{shrink:true}}
                        InputProps={{
                            readOnly: true,
                            classes: {
                                input: classes.inputBlocked
                            }
                        }}/> 
                </Grid>
                {full &&
                    <>
                        <Grid item xs={2}>
                            <TextField 
                                label={tMvm("status")} 
                                name={"statusPart" + movementType}
                                control={control}
                                fullWidth
                                InputLabelProps={{shrink:true}}
                                InputProps={{
                                    readOnly: true,
                                    classes: {
                                        input: classes.inputBlocked
                                    }
                                }}/> 
                        </Grid>

                        <Grid item xs={2}>
                            <TextField
                                label={tMvm("entranceDate")}
                                name={"entranceDatePart" + movementType}
                                control={control} 
                                fullWidth
                                type={mvm.entranceDate ? "datetime-local" : "text"}
                                InputLabelProps={{shrink:true}}
                                InputProps={{
                                    readOnly: true,
                                    classes: {
                                        input: classes.inputBlocked
                                    }
                                }}/> 
                        </Grid>

                        <Grid item xs={2}>
                            <TextField
                                label={tMvm("exitDate")}
                                name={"exitDatePart" + movementType}
                                control={control} 
                                fullWidth
                                type={mvm.exitDate ? "datetime-local" : "text"}
                                InputLabelProps={{shrink:true}}
                                InputProps={{
                                    readOnly: true,
                                    classes: {
                                        input: classes.inputBlocked
                                    }
                                }}/> 
                        </Grid>
                    </>
                }
            </Grid>
        </Grid>
    )
}

export default MvmCompositionPartInfo

